import migration20250522 from './2025-05-22_NOVA-1100';
import migration20250626 from './2025-06-26_NOVA-632';
import migration20261015 from './2026-10-15_NOVA-2246';
import migration20261029 from './2026-10-29_NOVA-2210';

/**
 * Migration scripts must be inserted chronologically,
 *
 * These will be run in the order presented by this array, from earliest to latest
 */
const allMigrations = [
    migration20250522,
    migration20250626,
    migration20261015,
    migration20261029
];

/**
 * The latest version of the redux persist state should match the last index of the migrations array
 *
 * This value will be used to compare the `version` in the browser's localStorage.
 * When this is higher, the migration script will run.
 */
export const version = allMigrations.length - 1;

/**
 * Mapping of persist version to migration script
 *
 * @see {@link https://github.com/rt2zz/redux-persist/blob/master/docs/migrations.md | redux persist migration scripts}
 */
export const migrations = allMigrations.reduce((acc, script, idx) => {
    acc[idx] = script;
    return acc;
}, {});
